var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('h5',{staticClass:"text-center"},[_vm._v("Activación de cuenta")]),(_vm.error)?_c('small',{staticClass:"d-block text-center"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),(_vm.load)?_c('kurama-loader',{attrs:{"msj":_vm.loadMsj}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }